"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationTable = void 0;
const lodash_1 = __importDefault(require("lodash"));
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const styled_components_1 = __importDefault(require("styled-components"));
const Colors_1 = require("../../../../../Colors");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const common_1 = require("../../../../../common");
const server_1 = require("../../../../../server");
const ReservationItem_1 = __importDefault(require("./ReservationItem"));
const ReservationTitle_1 = require("./ReservationTitle");
const react_redux_1 = require("react-redux");
const account_1 = require("../../../../base/account");
const classes_1 = require("../../../../base/classes");
const Container002Styled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: ${props => props.$isMobile && props.$isTeacher && '0px !important'};
	padding: ${props => props.$isTeacher ? '0px' : !props.$isDesktop ? '20px' : '28px 42px 10px 42px'};
	background: white;
	border-radius: ${props => (props.$isMobile ? '0px' : '16px')};

	.reservation-item {
		&.status {
			text-align: center;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.head-live_status {
		justify-content: center;
	}

	.qna-list-001 {
		/* padding: 0px 0px 36px 0px; */
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex: 1;
		position: relative;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-radius: 40px;
			padding: ${props => (!props.$isDesktop ? '12px 20px 12px 20px' : '6px 28px 6px 28px')};
			display: flex;
			flex-direction: row;
			gap: ${props => (!props.$isDesktop ? '12px' : '24px')};
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-grey, #666666);
				text-align: left;
				font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
				${props => props.$isMobile
    ? `  font-size: 12px;
						line-height: 150%;
						letter-spacing: -0.02em;`
    : props.$isDesktop
        ? `font-size: var(--b3-font-size, 16px);
				line-height: var(--b3-line-height, 32px);
				letter-spacing: var(--b3-letter-spacing, -0.02em);
				`
        : `  font-size: 14px;
						line-height: 150%;
						letter-spacing: -0.02em;`}
				font-weight: var(--b3-font-weight, 400);
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: ${props => (!props.$isDesktop ? '20px' : '24px 20px 24px 20px')};
			display: flex;
			flex-direction: row;
			gap: ${props => (!props.$isDesktop ? '12px' : '24px')};
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			text-align: left;
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			${props => props.$isMobile
    ? `
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;`
    : props.$isDesktop
        ? ` font-size: var(--b3-font-size, 16px);
			line-height: var(--b3-line-height, 32px);
			letter-spacing: var(--b3-letter-spacing, -0.02em);`
        : `
			font-size: 14px;
			line-height: 150%;
			letter-spacing: -0.02em;`}
			font-weight: var(--b3-font-weight, 400);

			&.selected {
				color: var(--tur-d, #479da6);
			}
		}

		.mobile_item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 16px 0px 16px 0px;
			display: flex;
			flex-direction: column;
			gap: 4px;
			align-items: flex-start;
			justify-content: center;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;
		}
	}

	.live-list-001 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex: 1;
		position: relative;
		min-height: ${props => props.$isDesktop ? '344px' : props.$isTablet && !props.$isTeacher ? '300px' : 'unset'};

		${props => props.$isMobile
    ? `background: var(--color-white, #ffffff); 
			border-radius: 10px;
			padding: 0px;


			.table-item-wrap {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				flex-direction: column;
			}
			`
    : `padding: 0px;`}

		${props => props.$isTablet &&
    `
			padding: 0px;
			.reservation-btn {
				width: 56px;
			}
			`}
		

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-radius: 40px;
			padding: 6px 28px 6px 28px;
			display: flex;
			flex-direction: row;
			gap: 28px;
			align-items: center;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			color: var(--color-grey, #666666);
			text-align: left;
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			${props => props.$isDesktop
    ? `
			font-size: var(--b3-font-size, 16px); 	
			line-height: var(--b3-line-height, 32px);`
    : `font-size: var(--b3-font-size, 14px); 	
			line-height: 150%;`}

			font-weight: var(--b3-font-weight, 400);
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}

		.scroll-content {
			display: flex;
			flex-direction: column;
			gap: 0px;
			align-items: flex-start;
			justify-content: flex-start;
			align-self: stretch;
			flex: 1;
			position: relative;
			box-sizing: border-box;
			height: unset;
		}

		.item {
			width: 100%;
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 20px 28px 20px 28px;
			display: flex;
			flex-direction: row;
			gap: 28px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			cursor: pointer;

			color: var(--color-black, #101010);
			text-align: left;
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);

			${props => props.$isDesktop
    ? `font-size: var(--b3-font-size, 16px);
			line-height: var(--b3-line-height, 32px);`
    : `font-size: var(--b3-font-size, 14px);
			line-height: 150%;`}
			font-weight: var(--b3-font-weight, 400);
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}

		.mobile_item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 16px 0px 16px 0px;
			display: flex;
			flex-direction: column;
			gap: 4px;
			align-items: flex-start;
			justify-content: center;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			.contents {
				color: var(--bule, #3c5295);
				text-align: left;
				font-family: 'Noto Sans KR', sans-serif;
				font-size: 12px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 400;
				position: relative;
				align-self: stretch;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}

			/* .title {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: 'Noto Sans KR', sans-serif;
				font-size: 14px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 600;
				position: relative;
				flex: 1;
				display: flex;
				align-items: center;
				justify-content: flex-start;
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
			} */

			.desc {
				display: flex;
				flex-direction: row;
				gap: 10px;
				color: var(--color-grey-l, #83868a);
				text-align: left;
				font-family: 'Noto Sans KR', sans-serif;
				font-size: 12px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 400;
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}
	}
	.underline {
		color: var(--tur, #3ab2bf);

		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${props => (props.$isDesktop ? '16px' : '14px')};
		line-height: 32px;
		font-weight: 400;
		text-decoration: underline;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;

		&_black {
			color: var(--color-black, #101010);
		}
	}

	${props => props.$isMobile &&
    `
		.underline {
			cursor: pointer;
		}

		
	}`}

	.empty_data {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		min-height: 100px;
	}

	.mobile_item {
		.title {
			max-width: 80%;
		}
		.big {
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 14px;
			font-weight: 600;
		}
	}
`;
exports.ReservationTable = react_1.default.memo(({ isClosed = false, isPrevious = false, isAttendance = false, selectedId, setSelectedId, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { classesId, isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const hiddenMenus = (0, react_redux_1.useSelector)((state) => (0, classes_1.getHiddenMenus)(state));
    const noReplay = hiddenMenus?.includes('replay') || hiddenMenus?.includes('replay-student');
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const historyStore = (0, GlobalStateProvider_1.useHistoryStore)();
    const count = isTeacher || isMobile ? 10 : 4;
    const [previousPageState, setPreviousPageState] = (0, react_1.useState)(); // 이전 페이지의 상태를 저장
    const [previousSearchContent, setPreviousSearchContent] = (0, react_1.useState)(''); // 이전 검색어를 저장
    const prevSearchOptionRef = react_1.default.useRef({}); // 이전 검색 옵션을 저장하는 ref
    const [page, setPage] = (0, react_1.useState)(0);
    const [testData, setTestData] = (0, react_1.useState)([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const [searchOption, setSearchOption] = (0, react_1.useState)({});
    const [isClosedState, setIsClosedState] = (0, react_1.useState)(isClosed);
    const [spareLiveDatas, setSpareLiveDatas] = (0, react_1.useState)(undefined);
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        // [강의모드, 제목, 수업일자, 진행시간, 진행자, 참석인원, 질의/응답, 상태] : 강의 목록(강사)
        // [No, 강의 제목, 수업일자, 시작시간, 진행시간, 참석인원, 비고] : 강의 목록(학생)
        const headTitleList = isMobile
            ? []
            : isAttendance
                ? [
                    { title: 'class_name', space: 3, sort: false, minWidth: 160 },
                    { title: 'classTime', space: 2, sort: false },
                    { title: 'participantMember', space: 1, sort: false },
                ]
                : [
                    { title: 'live_class', space: 1, sort: false },
                    { title: 'live_title', space: 3, sort: false },
                    { title: 'classDate', space: 2, sort: false },
                    { title: 'progress_time', space: 1, sort: false },
                    { title: 'progresser', space: 1, sort: false },
                    // { title: 'numberOfAttendees', space: 1, sort: false },
                    // { title: 'questionAndAnswer', space: 1, sort: false },
                    ...(!isClosed && isTeacher
                        ? [{ title: 'etc', space: 2, sort: false }]
                        : []),
                    ...(isPrevious ? [] : [{ title: 'live_status', space: 2, sort: false }]),
                ];
        const tableReadDataKeys = isMobile
            ? isAttendance
                ? [
                    { title: 'title', space: 1 },
                    { title: 'dateAndParticipant', space: 1 },
                ]
                : [
                    ...(isMobile && isTeacher ? [{ title: 'status', space: 1 }] : []),
                    ...(!isClosed && isTeacher ? [{ title: 'etc', space: 1 }] : []),
                    ...(isMobile && !isTeacher ? [{ title: 'status', space: 1 }] : []),
                    { title: 'title', space: 3 },
                    { title: 'dutaionTime', space: 2 },
                    { title: 'host_name', space: 1 },
                ]
            : isAttendance
                ? [
                    { title: 'title', space: 3, minWidth: 160 },
                    { title: 'start_time', space: 2 },
                    { title: 'participant', space: 1 },
                ]
                : [
                    { title: 'type', space: 1 },
                    { title: 'title', space: 3 },
                    { title: 'start_time', space: 2 },
                    { title: 'progress_duration', space: 1 },
                    { title: 'host_name', space: 1 },
                    // { title: 'members', space: 1 },
                    // { title: 'qna_managers_id', space: 1 },
                    ...(!isClosed && isTeacher
                        ? [{ title: 'etc', space: 2, sort: false }] //[{ title: 'etc', space: 1, sort: false }]
                        : []),
                    ...(isPrevious ? [] : [{ title: 'status', space: 2, sort: false }]),
                ];
        // useMemo에서 반환
        return { headTitleList, tableReadDataKeys };
    }, [isPrevious, isTeacher, isClosed, isMobile, isTablet]);
    (0, react_1.useEffect)(() => {
        // 이전 페이지의 상태를 가져와서 적용
        const previousPage = historyStore.getRecentPageHistory(isPrevious ? 'previousListPage' : 'reservationListPage');
        if (previousPage) {
            // 이전 페이지의 상태를 적용
            if (!isAttendance) {
                setIsClosedState(previousPage.props.isClosedState);
                setSearchOption(previousPage.searchOption);
                setPreviousSearchContent(previousPage.searchOption[Object.keys(previousPage.searchOption)[0]]);
                setPage(previousPage.prePage);
                setPreviousPageState(previousPage);
            }
        }
        else {
            setIsClosedState(undefined);
            setSearchOption({ title: undefined });
            setPreviousSearchContent(undefined);
            setPage(0);
            setPreviousPageState(undefined);
        }
        historyStore.clearHistoryForPage(isPrevious ? 'previousListPage' : 'reservationListPage');
    }, [isPrevious, isAttendance]);
    const { data, refetch } = (0, server_1.useConferenceList)({
        ...(previousPageState
            ? previousPageState.preItems
            : {
                ...searchOption,
                ...(isAttendance ? { with_attendances: true } : {}),
                status: isClosedState ? ['closed'] : ['booked', 'held'],
                offset: page === 0 ? 0 : page * count,
                limit: count,
                orderby: isAttendance || isPrevious ? ['startline DESC'] : ['startline ASC'],
            }),
    });
    const { data: spareLiveData, refetch: refetchSpareLive } = (0, server_1.useSpareLiveStreaming)(classesId);
    const deleteMutation = (0, react_query_1.useMutation)(server_1.deleteConferenceList);
    const refetchList = (0, throttle_1.default)(() => {
        refetch();
    }, 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        setIsClosedState(isClosed);
        setTestData([]);
    }, [isClosed, isPrevious, isAttendance]);
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('CONFERENCE_STATUS_CHANGED', refetchList);
        return () => {
            APP.eventManager.unsubscribe('CONFERENCE_STATUS_CHANGED', refetchList);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        refetchList();
    }, [page, isMobile, isClosedState, searchOption]);
    (0, react_1.useEffect)(() => {
        if (!isMobile)
            return;
        const isSearchOptionChanged = !lodash_1.default.isEqual(prevSearchOptionRef.current, searchOption);
        if (isSearchOptionChanged) {
            setPage(0);
            setPreviousPageState(undefined);
            setTestData([]);
            prevSearchOptionRef.current = searchOption;
        }
    }, [isMobile, searchOption]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { total_count, items, found_count } = data;
            if (total_count > 0 && found_count === 0) {
                const maxPage = Math.max(0, Math.ceil(total_count / count) - 1);
                setPage(maxPage);
                return;
            }
            //이전 페이지 저장된 기록 초기화
            if (previousPageState) {
                setPreviousPageState(undefined);
            }
            if (total_count > 0) {
                const list = items.map(i => ({
                    ...i,
                }));
                setTestData(!isMobile
                    ? list
                    : (prevTestData) => {
                        const prevDataById = lodash_1.default.keyBy(prevTestData, 'id');
                        const newDataById = lodash_1.default.keyBy(list, 'id');
                        const mergedData = lodash_1.default.merge({}, prevDataById, newDataById);
                        const sorted = lodash_1.default.values(mergedData).sort((a, b) => {
                            // Compare start_time first
                            if (a.start_time < b.start_time)
                                return -1;
                            if (a.start_time > b.start_time)
                                return 1;
                            // If start_time is equal, compare creation_time
                            if (a.creation_time < b.creation_time)
                                return -1;
                            if (a.creation_time > b.creation_time)
                                return 1;
                            return 0;
                        });
                        return sorted;
                    });
                setTotalCount(total_count);
                const hasSpareLive = items.some(i => i.spare_live);
                if (hasSpareLive) {
                    refetchSpareLive();
                }
                return;
            }
        }
        setTestData([]);
        setTotalCount(0);
    }, [data]);
    (0, react_1.useEffect)(() => {
        if (spareLiveData) {
            setSpareLiveDatas(spareLiveData);
        }
    }, [spareLiveData]);
    const handlerFilterList = (filter) => {
        setSearchOption(filter);
    };
    const handlerMoreData = (page) => {
        if (!isMobile) {
            setPage(page);
        }
        else {
            setPage(prevPage => prevPage + 1);
        }
    };
    const handlerOneDel = async (id) => {
        await deleteMutation.mutateAsync(id);
        refetchList();
    };
    const handlerSelectItem = (item) => {
        setSelectedId(item.id);
    };
    const goToSpareLive = () => {
        if (spareLiveDatas && spareLiveDatas.player_url) {
            window.open(spareLiveDatas.player_url, 'popupPage', 'directories=no,titlebar=no,toolbar=no,status=no,menubar=no,location=yes,width=1920,height=964,scrollbars=yes');
        }
    };
    const savePreviousPage = () => {
        const historyItem = {
            preItems: {
                ...searchOption,
                ...(isAttendance ? { with_attendances: true } : {}),
                status: isClosedState ? ['closed'] : ['booked', 'held'],
                offset: page === 0 ? 0 : page * count,
                limit: count,
                orderby: isAttendance || isPrevious ? ['startline DESC'] : ['startline ASC'],
            },
            props: {
                isAttendance: isAttendance,
                isClosedState: isClosedState,
                isPrevious: isPrevious,
            },
            prePage: page,
            searchOption: searchOption,
            pageName: isPrevious ? 'previousListPage' : 'reservationListPage',
        };
        historyStore.pushHistory(historyItem);
    };
    const renderItem = (item, styles, index, isMobile) => (react_1.default.createElement(ReservationItem_1.default, { item: item, styles: styles, isMobile: isMobile, isAttendance: isAttendance, isTeacher: isTeacher, isClosed: isClosedState, tableReadDataKeys: tableReadDataKeys, handlerOneDel: handlerOneDel, savePreviousPage: savePreviousPage, isPrevious: isPrevious, goToSpareLive: goToSpareLive }));
    const renderEmpty = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "empty_data", style: { color: Colors_1.Colors.light_grey } }, t('conference.noConference'))), []);
    return (react_1.default.createElement(Container002Styled, { className: `task-board-container ${!isTeacher ? 'liveRoom' : 'reservation-table'}`, "$isTeacher": isTeacher, "$isMobile": isMobile, "$isDesktop": isDesktop, "$isTablet": isTablet, style: {
            ...(isMobile && !isTeacher && noReplay ? { height: "100%" } : {}),
        } },
        react_1.default.createElement(common_1.Table, { className: isAttendance ? 'qna-list-001' : 'live-list-001', showCheckBox: false, showIndex: !isMobile, indexOrder: isAttendance || isPrevious ? 'desc' : 'asc', selectedId: selectedId, isInfinite: !isMobile ? false : true, data: testData, totalCount: totalCount, page: page, pagingCount: isAttendance && isTablet ? 3 : 5, showCount: count, sortDefault: "id", headTitleList: headTitleList, renderTitle: isAttendance ? null : (react_1.default.createElement(ReservationTitle_1.ReservationTitle, { isPrevious: isPrevious, handlerFilterList: handlerFilterList, previousSearchContent: previousSearchContent })), renderItem: totalCount > 0 && renderItem, renderEmpty: totalCount <= 0 && renderEmpty, handlerMoreData: handlerMoreData, handlerSelectItem: setSelectedId && handlerSelectItem, forceShowheader: isMobile ? false : true, styles: {
                bodyWrapper: {
                    cursor: handlerMoreData || isAttendance ? 'pointer ' : 'default',
                },
            }, padding: isTeacher ? true : false })));
});
